import { render, staticRenderFns } from "./ClienteCom.vue?vue&type=template&id=08c0b9da&"
import script from "./ClienteCom.vue?vue&type=script&lang=js&"
export * from "./ClienteCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports